import { MA_TRANSACTIONS_FILTERS_SUMMARY_QUERY } from '../operations';
import { useQuery } from '@apollo/client';

export const useGetFiltersSummary = () => {
  const { data, previousData, loading, error } = useQuery(MA_TRANSACTIONS_FILTERS_SUMMARY_QUERY, {
    fetchPolicy: 'cache-and-network',
  });

  const maTransactionsSummary = loading
    ? previousData?.maTransactionsSummary
    : data?.maTransactionsSummary;

  return {
    data: maTransactionsSummary || {},
    loading,
    error,
  };
};
